import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const EmployeesCheckmark = (props: MyIconProps): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.501 20.5035V20.0974C14.5043 18.9418 15.4403 18.0058 16.5959 18.0025H19.9093C21.0649 18.0058 22.0009 18.9418 22.0042 20.0974V20.5035C22.0042 20.7798 21.7802 21.0038 21.504 21.0038H15.0012C14.725 21.0038 14.501 20.7798 14.501 20.5035Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3268 14.0408C16.0843 13.1717 16.4535 12.2478 17.2281 11.7852C18.0028 11.3226 18.9913 11.4357 19.6414 12.0614C20.2916 12.6871 20.4425 13.6705 20.0099 14.4624C19.5772 15.2542 18.6682 15.6585 17.7904 15.4494C17.0828 15.2809 16.5223 14.7415 16.3268 14.0408Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.99583 18.5027V18.0965C1.99913 16.9409 2.93511 16.005 4.09071 16.0017H7.40409C8.55968 16.005 9.49566 16.9409 9.49896 18.0965V18.5027C9.49896 18.779 9.27501 19.0029 8.99875 19.0029H2.49604C2.21979 19.0029 1.99583 18.779 1.99583 18.5027Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.8216 12.04C3.57907 11.1709 3.94826 10.247 4.72294 9.78439C5.49763 9.32176 6.48611 9.43489 7.13624 10.0606C7.78638 10.6863 7.93728 11.6697 7.50466 12.4615C7.07205 13.2534 6.16296 13.6577 5.28521 13.4486C4.57755 13.2801 4.01713 12.7407 3.8216 12.04Z"
      />
      <circle cx="13.0004" cy="5.9975" r="4.00167" />
      <path d="M14.346 5.20517L12.6653 6.88487L11.6549 5.87745" />
    </svg>
  );
};
